/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilesystemPermission
 */
export interface FilesystemPermission {
    /**
     * 
     * @type {number}
     * @memberof FilesystemPermission
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FilesystemPermission
     */
    path: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemPermission
     */
    readOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FilesystemPermission
     */
    user?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FilesystemPermission
     */
    group?: number | null;
}

export function FilesystemPermissionFromJSON(json: any): FilesystemPermission {
    return FilesystemPermissionFromJSONTyped(json, false);
}

export function FilesystemPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilesystemPermission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'path': json['path'],
        'readOnly': !exists(json, 'read_only') ? undefined : json['read_only'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'group': !exists(json, 'group') ? undefined : json['group'],
    };
}

export function FilesystemPermissionToJSON(value?: FilesystemPermission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'path': value.path,
        'read_only': value.readOnly,
        'user': value.user,
        'group': value.group,
    };
}


